import React, { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import "./register.css"
export default function Register() {
  const baseUrl =process.env.REACT_APP_SECOND_BACKEND_URL; 
  const navigate = useNavigate();
  const [previewSrc, setPreviewSrc] = useState(null);
  const [errorMessage, setErrorMessage] = useState(""); 
  const formik = useFormik({
    initialValues: {
      username: "",
      email: "",
      password: "",
      confirm_password: "",
      role: "",
      name: "",
      profile_picture: null, 
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Name is required").typeError("Name should be a string"),
      username: Yup.string().min(5, "Must be at least 10 characters").required("Username is required").max(20, "Username should be a maximum of 2 characters "),
      email: Yup.string().email("Invalid email format").required("Required"),
      password: Yup.string()
        .min(10, "Password should have a minimum of 10 characters")
        .required("Password is required")
        .max(20, "Passwords should have a maximum value of 20 characters")
        .matches(/[A-Z]/, "Password should include at least one capital letter")
        .matches(/[a-z]/, "Password should include at least one small letter")
        .matches(/[0-9]/, "Password must include at least one number")
        .matches(/[@$!%*?&]/, "Password must include at least one special character")
        .typeError("Password should be a string")        ,

      confirm_password: Yup.string().oneOf([Yup.ref("password")], "Passwords do not match"),
      role: Yup.string().required("Role is required").oneOf(["admin", "bank_owner", "customer", "farmer", "hotel_owner", "transport_owner"], "Role is required"),
      profile_picture: Yup.mixed().nullable(), // Allow profile picture to be nullable
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const payload = { ...values };
        
        if (values.profile_picture) {
          const reader = new FileReader();
          reader.onloadend = async () => {
            payload.profile_picture = reader.result;
            await submitRegistration(payload);
          };
          reader.readAsDataURL(values.profile_picture);
        } else {
          await submitRegistration(payload);
        }
      } catch (error) {
        console.error("Registration failed", error);
      } finally {
        setSubmitting(false);
        // setErrorMessage ("")
      }
    },
  });

  const submitRegistration = async (payload) => {
    try {
      const response = await fetch(`${baseUrl}/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
       },
        body: JSON.stringify(payload),
      });
  
      // Check if the response is not OK
      if (!response.ok) {
        if (response.status===500){//Check if it has a status code of 500
          const ErrorData=await response.json()          
          console.error(`An error ocurred registering user ${ErrorData.Error|| ErrorData.message}`)
          setErrorMessage("An error ocurred registering ,please try again")
          return
        }
        else{
          const errorData = await response.json(); // Parse the JSON error response
        setErrorMessage(errorData.Error || errorData.Message || "Registration failed. Please try again.");
        return; // Exit the function early
        }

      }
  
      const data = await response.json(); // Parse the successful response
      if (data.token) {
        localStorage.setItem("Virtual_business_token", data.token);
        const decodedToken = jwtDecode(data.token);
        const role = decodedToken.sub.role;
        alert(`You are a ${role}. You have logged in successfully.`);
        navigate("/loginUser");
      } else {
        setErrorMessage(data.error || "An unknown error occurred.");
      }
    } catch (error) {
      console.error(`Error registering user: ${error}`);
      setErrorMessage("Registration failed. Please try again.");
    }
  };  
  
  const handleFileChange = (event) => {
    if(!event.currentTarget.files.length>0)return
   
    const file = event.currentTarget.files[0];
    formik.setFieldValue("profile_picture", file);

    // Preview the image
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewSrc(reader.result);
    };
    reader.readAsDataURL(file);
  };
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 mt-2 mb-10">
    <div className="w-full max-w-2xl p-5 bg-white rounded-3xl border shadow-md lg:max-w-4xl lg:p-10 lg:m-2">
      <form onSubmit={formik.handleSubmit} className="flex flex-col">
      <label htmlFor="role" className="max-w-full min-w-fit font-bold mt-4 mb-4 text-lg">Role</label>
        <select
          id="role"
          name="role"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.role}
          className="max-w-full min-w-fit rounded-2xl bg-blue-50  h-12 "
        >
          <option value="">Select Role</option>          
          <option value="bank_owner">Bank Owner</option>
          <option value="hotel_owner">Hotel Owner</option>
          <option value="transport_owner">Transport Owner</option>
          <option value="farmer">Farmer</option>
          <option value="customer">Customer</option>
        </select>
        {formik.errors.role && formik.touched.role? <p className="text-red-500 italic">{formik.errors.role}</p>:null}
        
        <label htmlFor="profile_picture" className=" max-w-full min-w-fit rounded-lg  font-bold mt-4 mb-4  text-lg">Profile Picture</label>
        <input
          id="profile_picture"
          name="profile_picture"
          type="file"
          accept="image/*" 
          onChange={handleFileChange}
          className=" max-w-full min-w-fit  bg-blue-50 h-12 rounded-2xl text-center" 
        />
        

        {previewSrc && (
          <img src={previewSrc} alt="Profile Preview" className=" w-32 h-32 rounded-lg" />
        )}
         <label htmlFor="username" className="max-w-full min-w-fit rounded-lg  font-bold mt-4 mb-4  text-lg">Username</label>
         <input
          id="username"
          name="username"
          type="text"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.username}
          placeholder="Enter the username"
          className=" max-w-full min-w-fit  bg-blue-50 h-12 rounded-2xl text-center"
        />
        {formik.touched.username && formik.errors.username ? <p className="text-red-500 italic">{formik.errors.username}</p> : null}

        <label htmlFor="email" className="max-w-full min-w-fit rounded-lg  font-bold mt-4 mb-4  text-lg">Email</label>
        <input
          id="email"
          name="email"
          type="email"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.email}
           className=" max-w-full min-w-fit  bg-blue-50 h-12 rounded-2xl text-center"
        />
        {formik.touched.email && formik.errors.email ? <p className="text-red-500 italic">{formik.errors.email}</p> : null}

        <label htmlFor="password" className="max-w-full min-w-fit  rounded-md  font-bold mt-4 mb-4  text-lg">Password</label>
        <input
          id="password"
          name="password"
          type="password"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.password}
                   className="max-w-full min-w-fit rounded-2xl bg-blue-50 h-12 text-center"
        />
        {formik.touched.password && formik.errors.password ? <p className="text-red-500 italic">{formik.errors.password}</p> : null}

        <label htmlFor="confirm_password" className="max-w-full min-w-fit  rounded-lg  font-bold mt-4 mb-4  text-lg">Confirm Password</label>
        <input
          id="confirm_password"
          name="confirm_password"
          type="password"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.confirm_password}
                    className="max-w-full min-w-fit rounded-2xl  bg-blue-50 h-12 text-center"
        />
        {formik.touched.confirm_password && formik.errors.confirm_password ? <p className="text-red-500 italic">{formik.errors.confirm_password}</p> : null}

        <label htmlFor="name" className=" max-w-full min-w-fit rounded-lg  font-bold mt-4 mb-4  text-lg">Name</label>
        <input
          id="name"
          name="name"
          type="text"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.name}
          placeholder="Enter the name"
                    className="max-w-full min-w-fit bg-blue-50 rounded-2xl  h-12 text-center"
        />
        {formik.touched.name && formik.errors.name ? <p className="text-red-500 italic">{formik.errors.name}</p> : null}
        
        <button
          type="submit"
          className="disabled:opacity-50 bg-blue-500 rounded-full mt-6 h-12"
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {formik.isSubmitting?"Registering...":"Register"}
        </button>
        {errorMessage && <p className="text-red-500 mt-10">{errorMessage}</p>} {/* Display error message */}
      </form>  
      <p>Already have a account</p>   
      <Link to="/loginUser" className=" mt-4 text-lg italic text-blue-500">Login</Link>
    </div>
  </div>
  )
}


